import { render } from "./MeusDadosEdit.vue?vue&type=template&id=34c1e064"
import script from "./MeusDadosEdit.vue?vue&type=script&lang=js"
export * from "./MeusDadosEdit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hd\\git\\enuve\\app-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__